import List from './List';
import CreateUpdate from './CreateUpdate';

export default { List, CreateUpdate };
